import { UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { SUB_MODULE } from "../apiRoutes";

// Define the expected response type (adjust based on your API response)
interface SubModule {
  name: string;
  description: string;
  createdAt: string;
  isActive: boolean;
}

interface SubModuleResponse {
  data: {
    records: SubModule[];
    pagination: { totalRecords: number }[];
  }[];
}

// Fetcher function (data optional)
const fetchSubModule = async ({ data = {} }: { data?: FieldValues }) => {
  const response = await axiosAuth.get<SubModuleResponse>(SUB_MODULE, {
    params: data,
  });
  return response.data;
};

// Main query hook
const useGetSubModules = (
  data?: FieldValues,
  queryParams?:
    | UseQueryOptions<
        SubModuleResponse,
        Error,
        SubModuleResponse,
        ["subModule", FieldValues | undefined]
      >
    | UseMutationOptions<any, Error>
) =>
  useQuery<SubModuleResponse, Error, SubModuleResponse, ["subModule", FieldValues | undefined]>({
    queryKey: ["subModule", data],
    queryFn: () => fetchSubModule({ data }),
    ...(queryParams as any),
  });

export default useGetSubModules;
